import { render, staticRenderFns } from "./Lunkuo.vue?vue&type=template&id=c22de772&"
import script from "./Lunkuo.vue?vue&type=script&lang=js&"
export * from "./Lunkuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports